'use client'

import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Container, Row, Col, Image, Button, Form } from 'react-bootstrap'
import { Recipe } from './tipos/Recipe'
import { ArrowLeft, Printer, Share2 } from 'lucide-react'

const RecipeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const [recipe, setRecipe] = useState<Recipe | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        const response = await axios.get<Recipe>(`https://rednext31.ddns.net:3005/api/recipes/${id}`)
        setRecipe(response.data)
      } catch (error) {
        console.error('Error fetching recipe:', error)
      }
    }

    fetchRecipe()
  }, [id])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handlePrint = () => {
    window.print()
  }

  const handleShare = async () => {
    if (navigator.share && recipe) {
      try {
        await navigator.share({
          title: recipe.title,
          text: `Mira esta receta: ${recipe.title}`,
          url: window.location.href,
        })
        console.log('Contenido compartido exitosamente')
      } catch (error) {
        console.error('Error al compartir:', error)
      }
    } else {
      alert('La funcionalidad de compartir no es compatible con este navegador.')
    }
  }

  const placeholderSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="600" height="400"> 
    <rect width="100%" height="100%" fill="#ddd" />
    <text x="50%" y="50%" font-size="24" fill="#aaa" dy=".3em" text-anchor="middle">Sin Imagen</text>
  </svg>
`

  if (!recipe) {
    return <div>Loading...</div>
  }

  return (
    <Container className="my-5">
      <Row className="mb-3">
        <Col xs={4}>
          <Button variant="outline-primary" onClick={handleGoBack} className="w-100">
            <ArrowLeft className="me-2" size={18} />
            Volver
          </Button>
        </Col>
        <Col xs={4}>
          <Button variant="outline-primary" onClick={handlePrint} className="w-100">
            <Printer className="me-2" size={18} />
            Imprimir
          </Button>
        </Col>
        <Col xs={4}>
          <Button variant="outline-primary" onClick={handleShare} className="w-100">
            <Share2 className="me-2" size={18} />
            Compartir
          </Button>
        </Col>
      </Row>  
      <Row>
        <Col md={6}>
          <Image src={recipe.portada || `data:image/svg+xml;charset=utf-8,${encodeURIComponent(placeholderSVG)}`} alt={recipe.title} fluid /> 
        </Col>
        <Col md={6}>
          <h1>{recipe.title}</h1>
          <p><strong>Tiempo de preparación:</strong> {recipe.cooktime} minutos</p>
          <p><strong>Dificultad:</strong> {recipe.dificultad}</p>
          <p><strong>Raciones:</strong> {recipe.raciones}</p>
          <h3>Ingredientes</h3>
          <ul className="ingredientes-list">
            {recipe.ingredientes.map((ingr) => (
              <li key={ingr.id_ingr} className="ingrediente-item">
                <span className="ingrediente-name">{ingr.name}</span>
                <span className="ingrediente-quantity">{ingr.quantity}</span>
                <span className="ingrediente-units">{ingr.unit}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <h3>Preparación</h3>
          <div className="mb-4">
            <div dangerouslySetInnerHTML={{ __html: recipe.description }} />
          </div>
          {recipe.bdes2 && recipe.description2 && (
            <div className="mb-4">
              <div dangerouslySetInnerHTML={{ __html: recipe.description2 }} />
            </div>
          )}
          {recipe.bdes3 && recipe.description3 && (
            <div className="mb-4">
              <div dangerouslySetInnerHTML={{ __html: recipe.description3 }} />
            </div>
          )}
          {recipe.bdes4 && recipe.description4 && (
            <div className="mb-4">
              <div dangerouslySetInnerHTML={{ __html: recipe.description4 }} />
            </div>
          )}
          {recipe.bdes5 && recipe.description5 && (
            <div className="mb-4">
              <div dangerouslySetInnerHTML={{ __html: recipe.description5 }} />
            </div>
          )}
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={2}>
          <Button variant="outline-primary" onClick={handleGoBack} className="w-100">
            <ArrowLeft className="me-2" size={18} />
            Volver
          </Button>
        </Col>
        <Col xs={2}>
          <Button variant="outline-primary" onClick={handlePrint} className="w-100">
            <Printer className="me-2" size={18} />
            Imprimir
          </Button>
        </Col>
      </Row>  
    </Container>
  )
}

export default RecipeDetail